import OurCompany from './OurCompany';

export default OurCompany;
